import {
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'app-online-payment-view',
  templateUrl: './online-payment-view.component.html',
  standalone: false
})
export class OnlinePaymentViewComponent implements OnInit {
  @Input() data: any = {};
  @Input() message = '-';
  useCrossBorderPayment = window.location.host !== 'account.qne.cloud';

  constructor() {}

  ngOnInit(): void {
    return;
  }
}
